// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-66cf8d9f] li:last-child:not(:first-child) .subnav{right:0}", "",{"version":3,"sources":["webpack://./src/js/components/ClickMenu.vue"],"names":[],"mappings":"AAEE,0DACE,OADJ","sourcesContent":["\n::v-deep {\n  li:last-child:not(:first-child) .subnav {\n    right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
